import LottiePlayer from 'lottie-web';

const players = document.querySelectorAll('.lottie-player:not(.is-initialized)');

players.forEach(player => {
	// path is required
	if (!player.hasAttribute('data-path')) {
		return;
	}

	// initialize instance
	player.classList.add('is-initialized');
	const lottie = LottiePlayer.loadAnimation({
		container: player,
		renderer: 'svg',
		path: player.getAttribute('data-path'),
		loop: (player.getAttribute('data-loop') ?? 'true') === 'true',
		autoplay: (player.getAttribute('data-autoplay') ?? 'true') === 'true',
	});

	lottie.addEventListener('DOMLoaded', () => {
		// custom random setting (starts animation at random frame)
		if ((player.getAttribute('data-random') ?? 'false') === 'true') {
			const frames = lottie.getDuration(true);
			const randomFrame = Math.floor(Math.random() * frames);
			if (lottie.isPaused) {
				lottie.goToAndStop(randomFrame, true);
			} else {
				lottie.goToAndPlay(randomFrame, true);
			}
		}

		//if player has class footer-lottie-player, set the animation to play on hover
		if (player.classList.contains('footer-lottie')) {
			// if window is at least 768px wide, play animation on hover

			if (window.innerWidth >= 768) {
				player.addEventListener('mouseenter', () => {
					lottie.play();
				});
				player.addEventListener('mouseleave', () => {
					lottie.addEventListener('loopComplete', () => {
						lottie.goToAndStop(0, true);
					});
				});
			} else {
				// if window is less than 768px wide, play animation when scrolled into view
				new IntersectionObserver(
					entries => {
						if (entries[0].intersectionRatio >= 0.5) {
							// play animation 1 time
							setTimeout(() => {
								lottie.play();
								// pause animation when loop is complete
								lottie.addEventListener('loopComplete', () => {
									lottie.goToAndStop(0, true);
								});
							}, 1000);
						}
						if (entries[0].intersectionRatio === 0) {
							lottie.goToAndStop(0, true);
						}
					},
					{ threshold: [0, 0.5, 1] }
				).observe(player);
			}
		}

		if (player.getAttribute('data-static') === 'true') {
			lottie.goToAndStop(0, true);
		} else {
			// custom reveal setting
			new IntersectionObserver(
				entries => {
					if (entries[0].intersectionRatio >= 0.5) {
						lottie.play();
					}
					if (entries[0].intersectionRatio === 0) {
						lottie.goToAndStop(0, true);
					}
				},
				{ threshold: [0, 0.5, 1] }
			).observe(player);
		}
	});
});
